var React = require('react');

function SafetyGlass (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M51.3298 1.8H65.1512L42.5431 24.47H26.3127L18.0763 16.2335L16.8035 17.5063L23.7671 24.47H0.00973511V67.78H68.2297V24.47H45.0852L66.4198 3.07696V16.87H68.2198V0H51.3298V1.8ZM40.748 26.27H28.1127L34.439 32.5963L40.748 26.27ZM25.5671 26.27L34.4407 35.1436L43.2901 26.27H66.4297V65.98H1.80974V26.27H25.5671ZM22.4759 35.4066L9.76594 48.1066L8.49365 46.8333L21.2037 34.1333L22.4759 35.4066ZM17.4461 48.1063L23.9261 41.6263L22.6533 40.3535L16.1733 46.8335L17.4461 48.1063ZM46.8535 58.6033L59.5635 45.8933L60.8363 47.1661L48.1263 59.8761L46.8535 58.6033ZM51.8833 45.8933L45.4033 52.3733L46.6761 53.6461L53.1561 47.1661L51.8833 45.8933Z","fill":"#1D1D1B"}));
}

SafetyGlass.defaultProps = {"width":"69","height":"68","viewBox":"0 0 69 68","fill":"none"};

module.exports = SafetyGlass;

SafetyGlass.default = SafetyGlass;
